import { useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { getMerchantsOptions } from '~features/dashboard-filters/lib/get-merchants-options';

import { useMerchantsListQuery } from '~entities/merchant';

import { Multiselect } from '@breeze/rhf-adapters';

import type { FiltersValue } from '../filters/filters';

export function MerchantFilter<T>({
  onFilterChanged,
}: {
  onFilterChanged: () => void;
}) {
  const { control } = useFormContext<FiltersValue<T>>();
  const { data, isLoading } = useMerchantsListQuery();
  const merchantOptions = useMemo(
    () => (data ? getMerchantsOptions(data) : []),
    [data]
  );

  return (
    <Controller
      control={control}
      name="merchantIds"
      render={(fieldProps) => (
        <Multiselect
          {...fieldProps}
          label="Merchants"
          size="m"
          searchThreshold={0}
          options={merchantOptions}
          loading={isLoading}
          onClose={onFilterChanged}
        />
      )}
    />
  );
}
